module.exports = __webpack_public_path__ + "static/media/osbrosura01.0c9fd061.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/OfficeShoes/osbrosura01.jpg
// module id = 394
// module chunks = 0